
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop<boolean>({
    default: false,
    type: Boolean,
  });
}
export default class Integration extends Vue.with(Props) {}
